// extracted by mini-css-extract-plugin
module.exports =  {"metaIcon":"R64o7UrNYSwgiQDkOeaC"};